import {
  helpers,
  required as requiredValidator,
  email as emailValidator,
} from '@vuelidate/validators';

export default function useValidationRules() {
  const { t } = useI18n();
  const msg = (key: string) => () => t(key) as string;

  const required = helpers.withMessage(
    msg('validation_required'),
    requiredValidator,
  );
  const email = helpers.withMessage(msg('validation_email'), emailValidator);

  const checked = helpers.withMessage(
    msg('validation_required'),
    (value: unknown) => value === true,
  );

  const errorMessage = (field: any): string =>
    (field && field.$errors && field.$errors[0]?.$message) || '';

  const errorMessages = (field: any): string[] =>
    (field?.$errors ?? []).map((error: any) => error.$message);

  return { required, email, checked, errorMessage, errorMessages };
}
